module.exports = __webpack_public_path__ + "static/index/img/baikal-203.89c36dad.jpg";